/* (ignored) */


//////////////////
// WEBPACK FOOTER
// supports-color (ignored)
// module id = 1
// module chunks = 0 1